import { useEffect } from 'react';

import { Stages } from '@vk-hr-tek/ui/Stages';
import { useIsDesktop } from '@vk-hr-tek/ui/hooks';

import { useDispatch, useSelector } from '../../../../app/hooks';
import { PageLoading } from '../../../../layout';
import { useAuth } from '../../../hooks';
import {
  activateEmployee,
  verifyInviteCode,
  selectStage,
  selectStatus,
} from '../../../slice';
import { Page } from '../../../segments';

import { VerifyInviteInit } from './VerifyInviteInit';

const stepsWithCodeVerification = [
  {
    name: 'init',
    content: <VerifyInviteInit />,
    label: 'СНИЛС',
  },
  {
    name: 'phone',
    content: null,
    label: 'Телефон',
  },
  {
    name: 'verification',
    content: null,
    label: 'Код',
  },
  {
    name: 'finish',
    content: null,
    label: 'Пароль',
  },
];

const stepsWithoutCodeVerification = [
  {
    name: 'init',
    content: <VerifyInviteInit />,
    label: 'СНИЛС',
  },
  {
    name: 'finish',
    content: null,
    label: 'Пароль',
  },
];

const registerWithoutPhoneCodeVerify =
  window.REACT_APP_VKHRTEK_AUTH_SKIP_PHONE_VERIFICATION.toString() === 'true';

const steps = registerWithoutPhoneCodeVerify
  ? stepsWithoutCodeVerification
  : stepsWithCodeVerification;

export const VerifyInvite = () => {
  const dispatch = useDispatch();
  const stage = useSelector(selectStage);
  const status = useSelector(selectStatus);

  const isDesktop = useIsDesktop();

  const isAuthenticated = useAuth();

  useEffect(() => {
    const skipOnError = stage === 'error';
    const skipOnFinish = registerWithoutPhoneCodeVerify && stage === 'finish';

    if (!skipOnError && !skipOnFinish) {
      dispatch(verifyInviteCode());
    }
  }, [stage, dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(activateEmployee());
    }
  }, [isAuthenticated, dispatch]);

  if ((isAuthenticated && stage !== 'error') || status === 'idle') {
    return <PageLoading />;
  }

  return (
    <Page title="Регистрация">
      <Stages
        steps={steps}
        active={stage}
        showHeader
        fullWidth={registerWithoutPhoneCodeVerify}
        size={isDesktop ? 'medium' : 'small'}
      />
    </Page>
  );
};
